function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M17 5a1 1 0 01.992 1.13l-.808 6.165c-.08.615-.166.83-.306 1.046-.14.215-.328.38-.56.491-.231.11-.457.168-1.076.168H2.758c-.62 0-.845-.057-1.076-.168a1.356 1.356 0 01-.56-.491c-.14-.216-.226-.431-.306-1.046L.009 6.13A1 1 0 011 5h16zM6 0c1.18 0 2.168 2 3 2h7a1 1 0 011 1v.359c0 .223-.023.304-.067.385a.454.454 0 01-.189.19c-.081.043-.162.066-.385.066H1.641c-.223 0-.304-.023-.385-.067a.454.454 0 01-.19-.189C1.024 3.663 1 3.582 1 3.36V1.5A1.5 1.5 0 012.5 0H6z"
});

var SvgFolder = function SvgFolder(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14"
  }, props), _ref);
};

export default SvgFolder;